import styled from "styled-components";
import { Camera } from "@styled-icons/boxicons-solid";

export const Container = styled.div`
  display: flex;
  align-items: center;
  border-radius: 24px;
  padding: 2px;
  border: 2px rgba(255, 255, 255, 0.5) solid;
  position: absolute;
  bottom: 32px;
  z-index: 101;
  width: calc(100% - 48px);
  margin: 0 24px;
`;

export const BackgroungIcon = styled.div`
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(255, 255, 255, 0.35);
  border-radius: 20px;
  margin-right: 12px;
`;

export const IconCam = styled(Camera).attrs({ size: 24 })`
  color: white;
`;

export const Text = styled.article`
  font-size: 14px;
  letter-spacing: 1px;
  color: white;
`;
